import { Box, Badge as UCLBadge, View, makeUclComponent } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { primitive, spacing } from 'styles/constants';
export const thumbnailSize = {
  width: spacing.$17_5,
  height: spacing.$13_5,
};

export const ItemThumbnailContainer = Box.withConfig({
  ...thumbnailSize,
  alignItems: 'center',
});

export const ThumbnailBox = View.withConfig({
  ...thumbnailSize,
  borderRadius: primitive.$borderRadius,
  position: 'absolute',
  backgroundColor: primitive.$greyEleven,
  alignItems: 'center',
  shadow: 1,
  style: {
    shadowOpacity: 0.2,
    shadowRadius: 6,
  },
});

export const ThumbnailBehind = ThumbnailBox.withConfig({
  style: {
    shadowOpacity: 0.3,
    shadowRadius: 2,
  },
});

export const BadgeContainer = Box.withConfig({
  position: 'absolute',
  bottom: spacing.$2_5,
  left: spacing.$13_5,
  width: '$5',
  height: '$5',
  zIndex: 1,
});

export const Badge = UCLBadge.withConfig({
  width: '$5',
  height: '$5',
  style: {
    minWidth: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
});

export const StyledPicture = makeUclComponent(Picture).withConfig({
  width: spacing.$13_5,
  height: spacing.$13_5,
});
